import axios from '../utils/api'

import CONFIG from '../config'
import { isCachedItem } from '../utils/caching'

import {
  FETCH_COMMUNITY_REQUEST, FETCH_COMMUNITY_RESPONSE, FETCH_COMMUNITY_RESPONSE_ERROR,
  SAVE_COMMUNITY_REQUEST, SAVE_COMMUNITY_RESPONSE,
  LIST_COMMUNITIES_REQUEST, LIST_COMMUNITIES_RESPONSE, LIST_COMMUNITIES_RESPONSE_ERROR,
  LIST_COMMUNITY_UNITS_REQUEST, LIST_COMMUNITY_UNITS_RESPONSE, LIST_COMMUNITY_UNITS_RESPONSE_ERROR,
} from '../constants'

function getLoaderId(action) {
  if (action.id) {
    return action.id
  }
  if (action.communityId) {
    return action.communityId
  }
  if (action.community && action.community.id) {
    return action.community.id
  }
  return ''
}

export function fetchCommunity(id) {
  const communityId = parseInt(id, 10)
  // TODO: validation?

  return (dispatch, getState) => {
    if (isCachedItem(getState().communities, communityId)) {
      return
    }

    dispatch({
      type: FETCH_COMMUNITY_REQUEST,
      id: communityId,
      getLoaderId,
    })

    axios.get(`${CONFIG.apiBase}/communities/${communityId}`).then((response) => {
      dispatch({
        type: FETCH_COMMUNITY_RESPONSE,
        community: response.data.body,
        getLoaderId,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: FETCH_COMMUNITY_RESPONSE_ERROR,
        error,
        getLoaderId,
        community: {
          id: communityId,
        },
      })
    })
  }
}

export function addCommunity(community) {
  return (dispatch) => {
    dispatch({
      type: SAVE_COMMUNITY_REQUEST,
      community,
      getLoaderId,
    })

    axios.post(`${CONFIG.apiBase}/communities`, community).then((response) => {
      dispatch({
        type: SAVE_COMMUNITY_RESPONSE,
        community: response.data.body,
        getLoaderId,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: SAVE_COMMUNITY_RESPONSE,
        error,
        getLoaderId,
        community: {
          id: community.id,
        },
      })
    })
  }
}

export function saveCommunity(community) {
  return (dispatch) => {
    dispatch({
      type: SAVE_COMMUNITY_REQUEST,
      community,
      getLoaderId,
    })

    axios.put(`${CONFIG.apiBase}/communities/${community.id}`, community).then((response) => {
      dispatch({
        type: SAVE_COMMUNITY_RESPONSE,
        community: response.data.body,
        getLoaderId,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: SAVE_COMMUNITY_RESPONSE,
        error,
        getLoaderId,
        community: {
          id: community.id,
        },
      })
    })
  }
}

export function listCommunities() {
  return (dispatch, getState) => {
    if (isCachedItem(getState().communitiesByUser, 'current')) {
      return
    }

    dispatch({ type: LIST_COMMUNITIES_REQUEST })

    axios.get(`${CONFIG.apiBase}/communities`).then((response) => {
      dispatch({
        type: LIST_COMMUNITIES_RESPONSE,
        communities: response.data.body,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: LIST_COMMUNITIES_RESPONSE_ERROR,
        error,
        communities: [],
      })
    })
  }
}

export function listCommunityUnits(id) {
  const communityId = parseInt(id, 10)
  return (dispatch, getState) => {
    if (isCachedItem(getState().unitsByCommunity, communityId)) {
      return
    }

    dispatch({
      type: LIST_COMMUNITY_UNITS_REQUEST,
      communityId,
      getLoaderId,
    })

    axios.get(`${CONFIG.apiBase}/communities/${communityId}/units`).then((response) => {
      dispatch({
        type: LIST_COMMUNITY_UNITS_RESPONSE,
        communityId,
        getLoaderId,
        units: response.data.body,
        perms: response.data.perms,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: LIST_COMMUNITY_UNITS_RESPONSE_ERROR,
        error,
        communityId,
        getLoaderId,
        units: [],
        perms: null,
      })
    })
  }
}
